import { render } from "./HumanPassport.vue?vue&type=template&id=82c6c210&scoped=true"
import script from "./HumanPassport.vue?vue&type=script&lang=js"
export * from "./HumanPassport.vue?vue&type=script&lang=js"

import "./HumanPassport.vue?vue&type=style&index=0&id=82c6c210&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c6c210"]])

export default __exports__